import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button } from '@shoflo/polymer/components/Button/Button';
import { Alert } from '@shoflo/polymer/components/Alert/Alert';
import ModalPage from 'containers/pages/ModalPage/ModalPage';
import { StyledAlertContainer, StyledButtonContainer } from './SignupErrorModal.styled';
import { DISMISS_SIGNUP_ERROR } from 'actions/Types';

const SignUpErrorModal = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const isOpen = useSelector((state) => state.signUpError);

    const handleDismiss = useCallback(() => dispatch({ type: DISMISS_SIGNUP_ERROR }), [dispatch]);
    const handleLogin = useCallback(() => {
        dispatch({ type: DISMISS_SIGNUP_ERROR });
        history.push('/login');
    }, [dispatch, history]);

    return isOpen ? (
        <ModalPage header='Sign Up Error'>
            <StyledAlertContainer>
                <Alert
                    type='warning'
                    title='Could not complete sign-up. Please verify your details or try logging in.'
                    size='small'
                />
            </StyledAlertContainer>
            <StyledButtonContainer>
                <Button onClick={handleDismiss} color='secondary'>Dismiss</Button>
                <Button onClick={handleLogin} color='primary'>Login</Button>
            </StyledButtonContainer>
        </ModalPage>
    ) : null;
};

export default SignUpErrorModal;
